import React from 'react'
import { Route, Switch } from 'react-router'
import ReportTransports from './ReportTransports'

const Components = props => (
    <Switch>
        <Route exact path={props.match.url} component={ReportTransports} />
    </Switch>
)

export default Components
